// Nota privada da Central da IA (content_attributes.ai_center). Quando existe,
// a conversa mostra só o cartão compacto (AiCenterPrivateNote.vue) no lugar do
// corpo amarelo da nota: o texto da nota é o aviso que notifica o responsável
// e aparece na prévia da lista, e repeti-lo em cima do cartão e do balão no
// fim da conversa virava três camadas da mesma sugestão.
export const AI_CENTER_NOTE_KINDS = ['opportunity', 'property'];

export const aiCenterNoteItem = (contentAttributes, isPrivate) => {
  if (!isPrivate) return null;
  const item = contentAttributes?.aiCenter || contentAttributes?.ai_center;
  if (!item || !AI_CENTER_NOTE_KINDS.includes(item.kind)) return null;
  if (!(item.item_id ?? item.itemId)) return null;
  return item;
};
